import config from '@plone/volto/registry';

// Formats eligible for the "Open in AGOL" action. Override by setting
// config.settings.agol.eligibleFormats in an addon's config.js.
export const DEFAULT_AGOL_ELIGIBLE_FORMATS = ['arcgis-map-server-layer'];

// Static suffix appended to the configured AGOL base URL.
export const AGOL_MAP_VIEWER_PATH = '/apps/mapviewer/index.html?url=';

export const getAgolEligibleFormats = (): string[] => {
  const configured = (config.settings as any)?.agol?.eligibleFormats;
  return Array.isArray(configured) && configured.length
    ? configured
    : DEFAULT_AGOL_ELIGIBLE_FORMATS;
};

// Parses the block-level "AGOL Eligible Formats" setting (comma-separated string).
export const parseAgolEligibleFormats = (value?: string): string[] =>
  (value || '')
    .split(',')
    .map((format) => format.trim())
    .filter(Boolean);

// Strips mime-type style prefixes (e.g. "application/x-", "application/") so
// values like "application/x-arcgis-map-server-layer" match the "arcgis-map-server-layer" slug.
const normalizeFormat = (format: string): string =>
  format.toLowerCase().replace(/^application\/(x-)?/, '');

// `eligibleFormats` overrides the block/global defaults when provided (e.g. from
// the block's "AGOL Eligible Formats" setting).
export const isAgolEligibleFormat = (
  formats: Array<string | undefined>,
  eligibleFormats?: string[],
): boolean => {
  const eligible = (
    eligibleFormats && eligibleFormats.length
      ? eligibleFormats
      : getAgolEligibleFormats()
  ).map((f) => normalizeFormat(f));
  return formats.some((format) => {
    if (!format) return false;
    const normalized = normalizeFormat(format);
    return eligible.some(
      (e) =>
        normalized === e || normalized.includes(e) || e.includes(normalized),
    );
  });
};

export const buildAgolUrl = (
  agolBaseUrl: string,
  datasetLink: string,
): string =>
  `${agolBaseUrl.replace(/\/$/, '')}${AGOL_MAP_VIEWER_PATH}${datasetLink}`;
